export default "__VITE_ASSET__BFfVOImr__"